<template>
  <transition name="slide-fade-right">
  <div class="mobile">
    <div class="mobile-top">



      <div class="logo"><img src="@/assets/img/logo-white.png" alt=""></div>
      <!--<div class="close">-->
        <!--<span class="close">-->
            <!--<svg-icon type="icon-close"/>-->
        <!--</span>-->
      <!--</div>-->
    </div>

    <div class="header-menu-ctr__item header-user-drowdown" v-if="isLogin === ''">
      <a href="/user-login" class="button purple round header-login-btn">
      <span class="button__wrp"><span class="button__txt unloggedTxt">
      Login
    </span>
        <span class="button__icon logoutIcon">
          <svg viewBox="0 0 20 20" class="icon">
            <use xlink:href="/icon/icons.svg#icon-user"></use>
          </svg>
        </span>
      </span>
      </a>
    </div>

    <div class="header-menu-ctr__item header-user-drowdown login-header" v-if="isLogin === 'true'">
      <div class="button purple round header-login-btn">
          <span class="icon-user" v-on:click="toggle('ranking')" >
          <svg viewBox="0 0 20 20" class="icon">
            <use xlink:href="/icon/icons.svg#icon-user"></use>
          </svg>
        </span>
        <span class="button__wrp"><span class="button__txt loggedTxt">
      {{ first_name }} {{ last_name }}
    </span>
        <span class="button__icon mycursorPointer " v-on:click="logout()">
          <svg viewBox="0 0 20 20" class="icon">
            <use xlink:href="/icon/icons.svg#icon-sign-out"></use>
          </svg>
        </span>
      </span>
      </div>
<div id="menu" class="row menuForMobile">  
  <ul class="menu">


	<li class="menu__item menu__item--dropdown " v-on:click="toggle('ranking')" :class="{'open' : dropDowns.ranking.open}">
		<a class="menu__link menu__link--toggle" href="#">
			<i class="menu__icon fa fa-angle-down"></i>
		</a>

		<ul class="dropdown-menu">
			<li class="dropdown-menu__item">
				<a class="dropdown-menu__link" href="/profil">Account Settings</a>
			</li>

			<li class="dropdown-menu__item">
				<a class="dropdown-menu__link" href="/profil/favorilerim">Favorites</a>
			</li>

			<li class="dropdown-menu__item">
				<a class="dropdown-menu__link" href="/profil/watchlist">Watchlist</a>
			</li>

			<li class="dropdown-menu__item">
				<a class="dropdown-menu__link" href="/profil/ratedmovies">Rated Movies</a>
			</li>

			<li class="dropdown-menu__item">
				<a class="dropdown-menu__link" href="/profil/yorumlarim">Comments</a>
			</li>      
		</ul>
	</li>

</ul>
</div>

      
    </div>

    <div class="footer__col">
      
      
      <div class="footer-links">
        <router-link class="footer-links__item" v-for="link in searchLinks" :key="link.id" :to="link.to">
                <span class="icon-font">
                  <svg-icon type="icon-search"/>
                </span>
          <span class="btn-txt">
                  {{ link.title }}
                </span>
        </router-link>
      </div>
      
      <div class="title color-white"><router-link to="/dvd-renting"> <span class="color-light-green">Holywood</span>
        <span style="color:white">Skyline</span> </router-link>
      </div>

     

      <div class="mobile-bottom">
        <router-link to="/ads-for-movies">Ads for Movies</router-link>
         <router-link to="/blog">Blog</router-link>
        <router-link to="/about">About</router-link>
        <router-link to="/media">Media</router-link>
        <router-link to="/contact">Contact</router-link>
        <router-link to="/frequently-asked-questions">FAQ</router-link>
      </div>

      <div class="footer-sec__links">
        <router-link :to="link.to" class="footer-sec__item" v-for="link in secLinks" :key="link.id">
            <span class="btn-txt">
              {{ link.title }}
            </span>
        </router-link>
      </div>

    </div>
  </div>
  </transition>
</template>

<script>
import { SET_USER_INFO, UNSET_TOKEN } from '@/store/mutations.type'
import { mapGetters } from 'vuex'
export default {
  name: 'Mobile',
  data () {
    return {
    dropDowns: {
      ranking: { open: false} 
    },      
      secLinks: [
        {
          id: 0,
          title: 'Privacy Policy',
          to: '/privacy-policy'
        },
        {
          id: 1,
          title: 'Cancellation',
          to: '/cancel-and-return-conditions'
        },
        {
          id: 2,
          title: 'Distance Sales Contract',
          to: '/distance-sales-contracts'
        },
        {
          id: 3,
          title: 'User Contract',
          to: '/user-contract'
        }
      ],
      searchLinks: [
       // {
       //   id: 0,
       //   title: 'DVD Renting',
        //  to: '/dvd-renting'
       // },
        {
          id: 1,
          title: 'Search by Genre',
          to: '/genres'
        },
        {
          id: 2,
          title: 'Search by Studios',
          to: '/studios'
        },
        {
          id: 2,
          title: 'Search by Series',
          to: '/series'
        },        
        {
          id: 3,
          title: 'Search a Movie',
          to: '/movie-search'
        },
        {
          id: 4,
          title: 'Search a Celebrity',
          to: '/Person'
        }        
      ],
      userMenu: [
        {
          id: 0,
          title: 'Account Settings',
          to: { name: 'UserSettings' }
        },
        {
          id: 1,
          title: 'Favorites',
          to: { name: 'UserFavorites' }
        },
        {
          id: 2,
          title: 'Comments',
          to: { name: 'UserComment' }
        }
/*         {
          id: 3,
          title: 'Teklifler',
          to: { name: 'UserOffers' }
        } */
      ]      
    }
  },
  methods: {
 toggle: function(dropdownName)
    {
      //alert(dropdownName)
       this.dropDowns[dropdownName].open = !this.dropDowns[dropdownName].open;
    },
    
    close: function()
    {
      for (dd in this.dropDowns)
      {
        this.dropDowns[dd].open = false;    
      }
    },    
   logout () {
      this.isLogin1 = false
      let data = { updateLogin: true, isLogin: '' }
      this.$store.commit(SET_USER_INFO, data )
      this.$store.commit(UNSET_TOKEN)
      window.localStorage.setItem('isLogin', '')
      window.localStorage.setItem('access_token', null)
      this.$router.push('/user-login')
    }  
  },
    computed: {
    ...mapGetters(['first_name', 'last_name', 'isLogin']),
    getTitle () {
      return 'Login'
    }
  }
}

</script>

<style lang="scss">
  @import "../assets/scss/components/mobile";

  .mycursorPointer { 
    cursor: pointer; }

body {
  margin: 2rem 0;
}

ul {
  list-style: none;
}

.menu {
 display:table;
 margin:0 auto;

	&__item {
		position: relative;
		padding-right: 3rem;

		&--dropdown {}
	}

	&__link {
		//color: $menu_link_color;
		text-transform: uppercase;

		&:hover {
			//color: $menu_link_hover_color;
		}

		&--toggle {}
	}

	&__icon {
		margin: 0 !important;
	}
}

.open .dropdown-menu {
	display: block;
}

.dropdown-menu {
	font-size: 0.9rem;
	position: absolute;
	min-width: 130px;
	top: 2.2rem;
	display: none;
	box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
	border-radius: 4px;

}

.dropdown-menu__item:first-child .dropdown-menu__link {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.dropdown-menu__item:last-child .dropdown-menu__link {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}

.dropdown-menu__link {
	display: block;

	padding: 1rem;
	color: blue;
	background-color: #fafafa;

	&:hover {
		color: green;
		background-color: #ccc;
	}

.mytable {
 display:table;
 margin:0 auto;
}
  
}

</style>